import { setupWorkspace } from './workspace';
import { AppName } from '../utils/Constants';
import { NativePlatform } from './Constants';

window.onload = async function (): Promise<void> {
	const query = window.location.hash.substr(1);
	const urlParams = new URLSearchParams(query);
	const platform = urlParams.get('native') as NativePlatform;
	const initData = urlParams.get('initData');
	await setupWorkspace({ platform, initData });
};

declare global {
	interface Window {
		setupWorkspaceForCEB(initData: string): Promise<void>;
	}
}

window.setupWorkspaceForCEB = async function (initData: string): Promise<void> {
	await setupWorkspace({ hostApp: AppName.CITRIXBROWSER, initData });
};
